/**
 * Default English translations for the AI Agent React library.
 * Users can override these by providing their own translations in the config.
 */
export const defaultTranslations = {
  // Panel title
  panelTitle: '',

  // Chat controls
  newChat: 'New chat',
  followUp: 'Follow up...',
  sendMessage: 'Send message',
  stopStreaming: 'Stop streaming',
  typeMessageToSend: 'Type a message to send',

  // Attachments
  attachFiles: 'Attach files',
  attachSelectionToContext: 'Attach selected text to context',
  attachments: 'Attachments',

  // Chat history
  chats: 'Chats',
  multiUserChats: 'Shared chats',
  noMultiUserChats: 'No shared chats yet.',
  noChatsYet: 'No chats yet.',
  untitledChat: 'Untitled chat',
  deleteChat: 'Delete chat',
  showChatHistory: 'Show chat history',
  hideChatHistory: 'Hide chat history',
  close: 'Close',

  // Loading states
  fetchingChats: 'Fetching chats…',
  fetchingChatError: 'Fetching chats failed',

  // Empty states
  helloThere: 'Hello there!',
  howCanIHelpYou: 'How can I help you today?',
  // Agent settings
  agentSettingsLoading: 'Loading agent settings…',
  agentSettingsError: 'Failed to load agent settings.',
  agentSettingsNoConfigurableTools: 'No configurable tools available.',
  agentSettingsNoToolsForAgent: 'No tools configured.',
  agentSettingsTooltip: 'Configure agent tools',

  // Form proposal tool
  formProposalFailed: 'Failed to propose form values',
  formProposalPreparing: 'Preparing form fill proposal…',
  formProposalNone: 'No form fields proposed.',
  formProposalHeaderPrefix: 'Proposed values for',
  formProposalApplied: 'Applied',
  formProposalRejected: 'Rejected',
  formProposalApplyAll: 'Apply all',
  formProposalShowAll: 'Show all',
  formProposalShowLess: 'Show less',
  formProposalApplyFieldPrefix: 'Apply',

  // Image generation tool
  imageGenerationFailed: 'Image generation failed',
  imageGenerationGenerating: 'Generating image…',
  imageGenerationNone: 'No images were generated.',
  imageGenerationOpen: 'Open full size',
  imageGenerationDownload: 'Download image'
} as const

export type Translations = typeof defaultTranslations

/**
 * Schema for validating translations config
 */
export const translationsSchema = {
  panelTitle: String,
  newChat: String,
  followUp: String,
  sendMessage: String,
  stopStreaming: String,
  typeMessageToSend: String,
  attachFiles: String,
  attachSelectionToContext: String,
  attachments: String,
  chats: String,
  multiUserChats: String,
  noMultiUserChats: String,
  noChatsYet: String,
  untitledChat: String,
  deleteChat: String,
  showChatHistory: String,
  hideChatHistory: String,
  fetchingChats: String,
  fetchingChatError: String,
  helloThere: String,
  howCanIHelpYou: String,
  close: String,

  // Agent settings
  agentSettingsLoading: String,
  agentSettingsError: String,
  agentSettingsNoConfigurableTools: String,
  agentSettingsNoToolsForAgent: String,
  agentSettingsTooltip: String,

  // Form proposal tool
  formProposalFailed: String,
  formProposalPreparing: String,
  formProposalNone: String,
  formProposalHeaderPrefix: String,
  formProposalApplied: String,
  formProposalRejected: String,
  formProposalApplyAll: String,
  formProposalShowAll: String,
  formProposalShowLess: String,
  formProposalApplyFieldPrefix: String
} as const
